<div class="main-container">
  <video class="home-video" preload="none" muted="" loop="" autoplay="" playsinline="">
    <source src="bg1.mp4" type="video/mp4" media="">
  </video>

  <div class="overlay"></div>
  <div class="pattern"></div>
  <div class="splash-container">
    <div class="splash-left">
      <div class="gradient-text">
        <div class="line1">Vertical Talent</div>
        <div class="line2">...Creator-first representation</div>
      </div>

      <div class="page-text">
        We're a talent representation firm founded by creators who understand what it takes to build online.
        Our focus is on building long-term careers through repeat brand partnerships, not one-off deals.
        By leveraging technology to better understand the market, pricing, and opportunities, we position our talent to make smarter decisions,
        build lasting brand relationships and grow real businesses - not just viral moments.
      </div>
      <div class="page-text">To learn more, please email: info&#64;verticaltalent.co</div>
    </div>
    <div class="splash-right">
      <div class="phone-frame-wrapper">
        <video class="new-phone-video" preload="none" muted="" loop="" autoplay="" playsinline="">
          <source src="vertical.mp4" type="video/mp4">
        </video>

        <svg class="phone-frame-svg"
             viewBox="0 0 270 540"
             xmlns="http://www.w3.org/2000/svg"
             preserveAspectRatio="none">

          <!-- Phone body with screen cutout (evenodd = transparent hole) -->
          <path
            d="M36,0 H234 Q270,0 270,36 V504 Q270,540 234,540 H36 Q0,540 0,504 V36 Q0,0 36,0 Z
               M14,52 H256 Q262,52 262,58 V480 Q262,486 256,486 H14 Q8,486 8,480 V58 Q8,52 14,52 Z"
            fill="#0d1b2e"
            fill-rule="evenodd"
          />

          <!-- Blue outer glow/border -->
          <rect x="1.5" y="1.5" width="267" height="537" rx="35" ry="35"
                fill="none" stroke="#2563eb" stroke-width="2.5" opacity="0.85"/>

          <!-- Top pill / Dynamic Island -->
          <rect x="103" y="18" width="64" height="18" rx="9" fill="#060e1a"/>

          <!-- Left volume buttons -->
          <rect x="-2" y="130" width="9" height="38" rx="3.5" fill="#1a3050"/>
          <rect x="-2" y="178" width="9" height="38" rx="3.5" fill="#1a3050"/>

          <!-- Right power button -->
          <rect x="263" y="140" width="9" height="50" rx="3.5" fill="#1a3050"/>

          <!-- Bottom home bar -->
          <rect x="105" y="498" width="60" height="5" rx="2.5" fill="#2a4060" opacity="0.7"/>
        </svg>
      </div>
    </div>
  </div>
</div>
<div>
  <app-creator-carousel></app-creator-carousel>
</div>
<div class="logos-container">
  <app-trusted></app-trusted>
</div>
